export default {
  props: {
    index: Number,
    total: Number,
  },
}
